import Vue from 'vue';
import template from './index.html';

export default Vue.extend({

  name: 'TabContent',
  template,
  props: {
    name: {
      required: true,
    },
  },

  computed: {
    activeClass() {
      if (this.$parent.activeTab === this.name) {
        return 'tabs__content--active';
      }

      return '';
    },
  },
});



// WEBPACK FOOTER //
// ./src/js/components/tabs/tab-content/index.js